import React from 'react';
import { useBnplStatus } from '../hooks/use-bnpl-status';
import { Dot } from '../../shared/atoms/Dot';
import { useProcessorType } from '../hooks';
import { useSelector } from 'react-redux';
import { selectCurrentLocationId } from 'redux/actions/location';
import { Loader } from '../atoms';
import { ActiveMerchantInfoStripe } from './active-merchant-info-stripe.component';
import { ActiveMerchantInfoJustifi } from './active-merchant-info-justifi.component';
import { css } from 'emotion';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,
};

export const ActiveMerchantStatus = () => {
  const locationId = useSelector(selectCurrentLocationId);
  const { isLoading, sunbitDotStatus } = useBnplStatus();
  const { isJustifiLocation, hasStripeProcessor, hasJustifiProcessor } =
    useProcessorType(locationId);

  const SunbitStatus = <>{isLoading ? <Loader /> : <Dot status={sunbitDotStatus} />}</>;
  const hasBothProcessors = hasStripeProcessor && isJustifiLocation;

  return (
    <div className={styles.container}>
      {hasStripeProcessor && (
        <ActiveMerchantInfoStripe
          showTitle={hasBothProcessors}
          SunbitStatus={SunbitStatus}
        />
      )}
      {isJustifiLocation && (
        <ActiveMerchantInfoJustifi
          showTitle={hasBothProcessors}
          SunbitStatus={!hasBothProcessors && SunbitStatus}
        />
      )}
    </div>
  );
};
